/**
 * Given an array of potentially nested filters, returns them in flattened form,
 * with a parent specified by slug rather than an array of children.
 * @param {Array} filters - Filters to be flattened.
 * @param {string|null} parent - The slug of the parent element, if any.
 * @returns {Array} Flattened filters.
 */
const flattenFilters = (filters, parent = null) => filters.reduce((acc, item) => [
  ...acc,
  {
    parent,
    slug: item.slug,
    suppress: item.suppress,
  },
  ...flattenFilters(item.children, item.slug),
], []);

export default flattenFilters;
